import React from 'react';
import PropTypes from 'prop-types';
import Filters from '../Filters/Filters';
import Posts from '../Posts/Posts';
import AppState from '../../context/app/AppState';

const App = ({ settings }) => {
  const data = JSON.parse(settings);

  if(!data) {
    return null;
  }

  const { api, baseUrl, currentLanguage, postType, taxonomies, postsPerPage, maxPages, translations, queryParams } = data;

  return (
    <AppState
      api={api}
      currentLanguage={currentLanguage}
      baseUrl={baseUrl}
      postType={postType}
      taxonomies={taxonomies}
      postsPerPage={postsPerPage}
      maxPages={maxPages}
      translations={translations}
      queryParams={queryParams}
    >
      <Filters/>
      <Posts/>
    </AppState>
  )
};

App.propTypes = {
  settings: PropTypes.string.isRequired,
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App/App.js